import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const GoogleDevice169: FC<Props> = (props) => (
  <Root viewBox="0 0 145.78 300.88" {...props}>
    <defs>
      <style>
        {'.google16-9_svg__cls-1{fill:#fff}.google16-9_svg__cls-4{fill:#eee}.google16-9_svg__cls-6{fill:#2d81ff}'}
      </style>
    </defs>
    <g id="google16-9_svg__\u30EC\u30A4\u30E4\u30FC_2" data-name="\u30EC\u30A4\u30E4\u30FC 2">
      <g id="google16-9_svg__\u30EC\u30A4\u30E4\u30FC_1-2" data-name="\u30EC\u30A4\u30E4\u30FC 1">
        <rect width={145.78} height={300.88} rx={21.72} />
        <path className="google16-9_svg__cls-1" d="M6.28 39.65h132.07v21.96H6.28z" />
        <path
          d="M138.27 39.65v-18A14.31 14.31 0 00124 7.33h-14.16v1.92a7.59 7.59 0 01-7.59 7.59H43.14a7.59 7.59 0 01-7.59-7.59V7.33h-15A14.31 14.31 0 006.28 21.64v18z"
          fill="#f2f2f2"
        />
        <rect x={12.31} y={23.42} width={116.48} height={11.38} rx={5.69} fill="#e7e7e7" />
        <path
          className="google16-9_svg__cls-4"
          d="M11.65 44.96h34.37v3.94H11.65zM120.88 51.32h12.48v3.94h-12.48zM11.65 51.05h55.23v4.21H11.65z"
        />
        <path
          className="google16-9_svg__cls-1"
          d="M6.28 133.6v145.64a14.31 14.31 0 0014.31 14.31H124a14.31 14.31 0 0014.31-14.31V133.6z"
        />
        <rect x={53.71} y={286.02} width={34.73} height={3.52} rx={1.76} />
        <path
          className="google16-9_svg__cls-4"
          d="M11.65 170.86h8.63v3.94h-8.63zM11.65 140.9h122.61v4.21H11.65zM11.65 161.1h122.61v4.21H11.65zM11.65 150.46h117.91v4.21H11.65zM11.65 183.78h122.61v4.21H11.65zM11.65 193.33h66.11v4.21H11.65z"
        />
        <path fill="none" stroke="#f5f5f5" strokeMiterlimit={10} d="M6.46 261.01h131.65" />
        <circle className="google16-9_svg__cls-6" cx={129.32} cy={272.22} r={4.77} />
        <circle className="google16-9_svg__cls-6" cx={92.43} cy={272.22} r={4.77} />
        <circle className="google16-9_svg__cls-6" cx={53.81} cy={272.22} r={4.77} />
        <circle className="google16-9_svg__cls-6" cx={16.93} cy={272.22} r={4.77} />
        <path fill="#424242" d="M6.15 61.58h132.23v73.29H6.15z" />
        <path className="google16-9_svg__cls-4" d="M6.27 202.38h132.11v58.22H6.27z" />
      </g>
    </g>
  </Root>
);

const Root = styled('svg')();

export default GoogleDevice169;
